export { default } from '../../components_CO/Footer';
